module.exports = __webpack_public_path__ + "img/logo.dffe0f3c.png";